import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import RSVP from 'rsvp';

class RoadmapStrategyRoadmapEditRoute extends Route {
  @service store;
  defaultStatus = [
    'ACTIVE',
    'READY',
    'READY FOR PLANNING',
    'DISCOVERY',
    'DRAFT',
  ];

  queryParams = {
    status: {
      refreshModel: false,
    },
    from: {
      refreshModel: false,
    },
    to: {
      refreshModel: false,
    },
    sources: {
      refreshModel: false,
    },
    product_managers: {
      refreshModel: false,
    },
    themes: {
      refreshModel: false,
    },
    teams: {
      refreshModel: false,
    },
  };

  setupController(controller, model) {
    super.setupController(...arguments);
    controller.set('initiatives', model.initiatives);
  }

  async model(params) {
    const _params = { ...params };
    delete _params['grouping'];
    if (_params.status == undefined || _params.status.length === 0)
      _params.status = this.defaultStatus;
    const roadmap = this.modelFor('roadmap.strategy.roadmap');
    return RSVP.hash({
      initiatives: this.store
        .query('initiative', _params)
        .then(async (results) => {
          const initiatives = results.slice();
          const promises = [];
          initiatives.forEach((initiative) => {
            promises.push(initiative.belongsTo('bon').load());
          });
          await Promise.all(promises);
          return results;
        }),
      scenarios: this.store.findAll('investment-scenario', {
        include: 'roadmap',
        reload: true,
      }),
      roadmap: roadmap,
      scenario: roadmap.get('investment-scenario'),
    });
  }
}

export default instrumentRoutePerformance(RoadmapStrategyRoadmapEditRoute);
